import { createContext, useContext, useEffect, useState } from "react";
import { authLogin, authMe, setToken, getToken } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = logged in

  useEffect(() => {
    if (!getToken()) { setUser(false); return; }
    authMe().then(setUser).catch(() => { setToken(null); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const data = await authLogin(email, password);
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };
  const logout = () => { setToken(null); setUser(false); window.location.href = "/login"; };

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}
